import { AbstractControl, ValidatorFn } from '@angular/forms';

export function url(): ValidatorFn {
    // const nameRe: RegExp = new RegExp(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
    const nameRe: RegExp = new RegExp(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/[^\s]*)?$/);

    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !nameRe.test(control.value) && { url: true }) || null;
}

export function videoUrl(): ValidatorFn {
    // const nameRe: RegExp = new RegExp(/(?:https?:\/\/)?(?:[A-z]+\\.)?youtube.com\/(@[\w\d]+$)|(c|channel|user|watch)(\/|\?)([A-z0-9-\\_]+)\/?/);
    const nameRe: RegExp = new RegExp(
        /^(?!.*youtube\.com\/shorts\/)(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
    );

    /**
     * Explicación:
     * ^(?!.*youtube\.com\/shorts\/): Esta es una afirmación de "no mirar hacia adelante" (negative lookahead)
     * que asegura que la URL no contiene "youtube.com/shorts/" en ninguna parte.
     * El resto de la expresión regular se mantiene igual para validar las URLs según tus requisitos iniciales.
     */

    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !nameRe.test(control.value) && { url: true }) || null;
}

export function imageUrl(): ValidatorFn {
    const nameRe: RegExp = new RegExp(
        /^(https:\/\/|www\.)[\w.-]+(?:\.[\w\.-]+)+[\w\-_~:/?#[\]@!$&'()*+,;=]*\.(jpg|jpeg|png|gif|bmp)$/i
    );

    return (control: AbstractControl): { [key: string]: any } | null =>
        (control.value && !nameRe.test(control.value) && { url: true }) || null;
}
